import styles from "./slider.module.css";
import { useEffect, useState } from "react";
import Icon from "./../../icons/icon";

const Slider = ({ index, instantScroll, instantScrollUp, data }) => {
  const [sliderIndex, setSliderIndex] = useState(0);

  const [showSection, setShowSection] = useState(false);

  useEffect(() => {
    switch (index) {
      case 1:
        return setSliderIndex(0);
      case 2:
        return setSliderIndex(1);
      case 3:
        return setSliderIndex(2);
      case 4:
        return setSliderIndex(3);
      case 5:
        return setSliderIndex(4);
      case 6:
        return setSliderIndex(5);
      case 7:
        return setSliderIndex(6);
      default:
        return;
    }
  }, [index]);

  return (
    <div
      className={styles.sliderWrapper}
      id="section2"
      style={{
        opacity: index >= 1 && index <= 7 ? 1 : 0,
        transitionDelay: index === 0 || index === 8 ? "0s" : ".75s",
      }}
    >
      <div className={styles.images}>
        {data.map((item, itemIndex) => (
          <div
            className={styles.imageWrapper}
            style={{
              opacity: sliderIndex === itemIndex ? 1 : 0,
              transform:
                sliderIndex > itemIndex
                  ? "translateY(-10px)"
                  : sliderIndex === itemIndex
                  ? "translateY(0)"
                  : "translateY(10px)",
              transitionDelay: sliderIndex === itemIndex ? "0.5s" : "0s",
            }}
            key={itemIndex}
          >
            <img
              src={process.env.PUBLIC_URL + `/json/sliderImage/${item?.image}`}
              style={{}}
              fill
              alt=""
            />
          </div>
        ))}
      </div>

      <div className={styles.overlay}></div>

      <div className={styles.slider}>
        <div className="narrow-container">
          <div className={styles.top}>
            {data.map((item, itemIndex) => (
              <div
                className={styles.item}
                key={itemIndex}
                style={{
                  opacity: sliderIndex === itemIndex ? 1 : 0,
                  transform:
                    sliderIndex > itemIndex
                      ? "translateY(-50px)"
                      : sliderIndex === itemIndex
                      ? "translateY(0)"
                      : "translateY(50px)",
                  transitionDelay: sliderIndex === itemIndex ? "0.5s" : "0s",
                }}
              >
                <h2>
                  {item.title.map((title) => (
                    <>
                      {title} <br />
                    </>
                  ))}
                </h2>
                <p>{item.text}</p>
              </div>
            ))}
          </div>

          <div className={styles.nav}>
            <div className={styles.counter}>
              <div>{sliderIndex + 1}</div> / <div>{data.length}</div>
            </div>
            <div className={styles.scrollBtn}>
              <div className={styles.up} onClick={instantScrollUp}>
                <Icon type="Chevron" />
              </div>
              <div className={styles.down} onClick={instantScroll}>
                <Icon type="Chevron" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Slider;
